export const defaultTheme = {
  primaryColor: '#263646',
  secondaryColor: '#24b9e8',
};

export const HEARTBEAT_TYPE_OVERALL = 'overall';
export const HEARTBEAT_TYPE_SECTION = 'section';

export const ASSESSMENT_NOT_IN_PROGRESS = 'Assessment is not in progress';

export const TRIGGER_TIMER = 'timer';
export const TRIGGER_BY_USER = 'user';

export const SECTION_STATUS_ENDED = 'completed';
export const SECTION_STATUS_IN_PROGRESS = 'in_progress';
export const SECTION_STATUS_NOT_STARTED = 'not_started';

export const DEFAULT_RESPONSE_DETAILS = {
  id: '',
  visited: false,
  answered: false,
  markedForReview: false,
  answer: [],
};

export const ResultStatus = Object.freeze({
  Success: 'SC',
  Error: 'ER',
  Fail: 'FL',
});

export const LogoStatus = Object.freeze({
  Accepted: 'AC',
  WrongAnswer: 'WA',
  NotAttempted: 'NA',
  RuntimeError: 'RE',
  CompilerError: 'CE',
  TimeLimit: 'TLE',
  Unknown: 'UA',
});

export const RECONNECTION_TIMEOUT = 10 * 1000;
export const RECONNECTION_ATTEMPT = 5;

export const FREE_FORM_EDITOR_ID = 'free_form_editor';

export const DEFAULT_TEMPLATES = [
  { language: 'python3', code: '# write code here' },
  { language: 'c', code: '// write code here' },
  { language: 'java', code: '// write code here' },
  { language: 'javascript', code: '// write code here' },
  { language: 'cpp', code: '// write code here' },
  { language: 'ruby3', code: '# write code here' },
];

export const defaultSurveyUrl = 'https://survey.zohopublic.in/zs/VhCAas';
